<template>
  <div
    v-if="confirm.show"
    class="BcConfirm fixed inset-0 overflow-y-auto"
    :class="{ 'BcConfirm--Visible': confirm.show }"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="
        flex
        items-end
        justify-center
        min-h-screen
        pt-4
        px-4
        pb-20
        text-center
        sm:block sm:p-0
      "
    >
      <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
        @click="confirm.cancel"
      ></div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
        >&#8203;</span
      >

      <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->

      <div
        v-if="confirm.show"
        class="
          BcConfirmContent
          inline-block
          align-bottom
          bg-white
          rounded-lg
          px-4
          pt-5
          pb-4
          text-left
          overflow-hidden
          shadow-xl
          transform
          transition-all
          sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6
        "
        :class="[
          { 'BcConfirmContent--Visible': confirm.show },
          { 'pt-14 sm:pt-14': confirm.withCloseIcon}
        ]"
      >
        <div>
          <div
            v-if="confirm.withIcon"
            class="
              mx-auto
              flex
              items-center
              justify-center
              h-12
              w-12
              rounded-full
              bg-green-100
              mb-3
            "
          >
            <svg
              class="h-6 w-6 text-green-600"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <button
            v-if="confirm.withCloseIcon"
            class="absolute top-4 right-4 flex items-center justify-center"
            @click="confirm.cancel"
          >
            <aw-icon
              icon="close"
              class="w-8 h-8"
            />
          </button>
          <component 
            :is="confirm.body"
            :confirm="confirm"
          />
        </div>
        <div
          class="
            mt-5
            sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense
          "
        >
          <button
            @click="confirm.yes"
            type="button"
            class="
              btn btn-primary
              w-full
              inline-flex
              justify-center
              sm:col-start-2 sm:text-sm
              "
            :class="confirm.buttonYesClass"
          >
            {{ $t(confirm.buttonYes) }}
          </button>
          <button
            @click="confirm.no"
            type="button"
            class="
              btn btn-secondary
              mt-3
              w-full
              inline-flex
              justify-center
              sm:mt-0 sm:col-start-1 sm:text-sm
            "
            :class="confirm.buttonNoClass"
          >
            {{ $t(confirm.buttonNo) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
const defaults = {
  show: false,
  header: 'Example confirmation!',
  text: null,
  buttonNo: 'No',
  buttonNoClass: '',
  buttonYes: 'Yes',
  buttonYesClass: '',
  withIcon: false,
  withCloseIcon: false,
  cancel: false,
  body: 'BcConfirmBody',
}

const confirm = ref({...defaults})

export function showConfirm (config) {
  const newConfirm = {...defaults, ...config}
  return new Promise((resolve) => {
    newConfirm.show = true
    newConfirm.yes = () => {
      confirm.value.show = false
      resolve(true)
    }
    newConfirm.no = () => {
      confirm.value.show = false
      resolve(false)
    }
    newConfirm.cancel = () => {
      confirm.value.show = false      
      resolve(null)
    }
    confirm.value = newConfirm
  })
}

export default {
  setup() {
    return {
      confirm: confirm
    }
  }
}
</script>

<style scoped>
.BcConfirm {
  z-index: 9999;
}
</style>
